import calendarService from '@/services/calendar/calendar.service';
import ITimeZone from '@/types/ITimeZone';
import { Box, Text } from '@chakra-ui/react';
import { Temporal } from 'temporal-polyfill';

interface IProps {
	plainDate: Temporal.PlainDate;
	locale: string;
	timeZone: ITimeZone;
}

export default function DateInfo(props: IProps) {
	const today = Temporal.Now.plainDateISO();
	const isToday = today.equals(props.plainDate);

	return (
		<Box
			id={props.plainDate.toString()}
			userSelect="none"
			display="flex"
			justifyContent="center"
			pt="1"
			fontSize="x-small"
			fontWeight={500}
			alignItems="space-between"
			px={2}
			py={1}
		>
			<Text
				textColor="gray.500"
				textTransform="capitalize"
				flex="1"
				textAlign="right"
				color={isToday ? 'primary.500' : 'gray.500'}
				fontWeight={isToday ? 600 : 500}
			>
				{calendarService.formatDate({
					date: new Date(props.plainDate.toZonedDateTime(props.timeZone).toInstant().epochMilliseconds),
					locale: props.locale,
					options: { day: 'numeric', weekday: 'short', timeZone: props.timeZone },
				})}
			</Text>
		</Box>
	);
}
